import React from "react";

const ExpenseTable = ({ items, totalAmount }) => {
  return (
    <div className="card shadow-sm mt-3">
      <div className="card-header bg-danger text-white">
        Expense Details
      </div>
      <div className="card-body p-0">
        <table className="table table-hover mb-0">
          <thead className="table-light">
            <tr>
              <th>Date</th>
              <th>Payee</th>
              <th>Description</th>
              <th>Payment Method</th>
              <th className="text-end">Amount</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center p-4 text-muted">
                  No expenses found for the selected period.
                </td>
              </tr>
            ) : (
              items.map((item) => (
                <tr key={item.id}>
                  <td>{item.date ? new Date(item.date).toLocaleDateString() : "-"}</td>
                  <td>{item.payee}</td>
                  <td>{item.description || "-"}</td>
                  <td>{item.payment_method}</td>
                  <td className="text-end fw-bold">{item.amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                </tr>
              ))
            )}
          </tbody>
          {items.length > 0 && (
            <tfoot className="table-light">
              <tr>
                <th colSpan="4" className="text-end">Total Expenses:</th>
                <th className="text-end text-danger fs-5">
                  {totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                </th>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
};

export default ExpenseTable;
